export default __webpack_public_path__ + "media/src/features/home-page-location-filter-widget/assets/mapPin-740f0525ac74bfa253909ae9d91ffb13.svg";